import { createSlice } from "@reduxjs/toolkit";
import { toGetTestimonies } from "../actions/testimonies.actions";

const initialState = {
  testimonies: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const testimoniesSlice = createSlice({
  name: "testimonies",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetTestimonies.pending, (state) => {
      state.testimonies = { list: [], status: "idle" };
    });
    builder.addCase(toGetTestimonies.fulfilled, (state, action) => {
      state.testimonies = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetTestimonies.rejected, (state, action) => {
      state.testimonies = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default testimoniesSlice.reducer;
